import { useLanguage } from "./LanguageContext";

export default function LanguagePicker({ onComplete }) {
  const { setLang } = useLanguage();

  const pickLang = (lang) => {
    setLang(lang);
    if (onComplete) onComplete();
  };

  const btnStyle = (hoverBg) => ({
    display: "flex",
    alignItems: "center",
    gap: "12px",
    width: "100%",
    padding: "16px 24px",
    border: "2px solid var(--blue-200)",
    borderRadius: "12px",
    background: "white",
    cursor: "pointer",
    fontSize: "1.1rem",
    color: "var(--blue-800)",
    fontFamily: "'Lato', sans-serif",
    fontWeight: 600,
    transition: "all 0.3s",
  });

  return (
    <div style={{
      position: "fixed",
      inset: 0,
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "rgba(30, 58, 95, 0.85)",
      backdropFilter: "blur(8px)",
    }}>
      <div
        className="animate-fade-in-up"
        style={{
          background: "white",
          borderRadius: "20px",
          padding: "48px 40px",
          maxWidth: "400px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
        }}
      >
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" style={{ margin: "0 auto 12px" }}>
          <circle cx="12" cy="12" r="10" stroke="var(--blue-500)" strokeWidth="1.5" />
          <path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" stroke="var(--blue-500)" strokeWidth="1.5" />
        </svg>

        <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: "1.8rem",
          color: "var(--blue-800)",
          marginBottom: "4px",
        }}>
          Welcome! / ¡Bienvenidos!
        </h2>

        <p style={{
          color: "#64748b",
          fontSize: "0.95rem",
          marginBottom: "32px",
        }}>
          Please select your language / Selecciona tu idioma
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <button
            onClick={() => pickLang("en")}
            style={btnStyle()}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "var(--blue-500)";
              e.currentTarget.style.background = "var(--blue-50)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "var(--blue-200)";
              e.currentTarget.style.background = "white";
            }}
          >
            <span style={{ fontSize: "1.5rem" }}>EN</span>
            <span>English</span>
          </button>

          <button
            onClick={() => pickLang("es")}
            style={btnStyle()}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "var(--blue-500)";
              e.currentTarget.style.background = "var(--blue-50)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "var(--blue-200)";
              e.currentTarget.style.background = "white";
            }}
          >
            <span style={{ fontSize: "1.5rem" }}>ES</span>
            <span>Español</span>
          </button>
        </div>
      </div>
    </div>
  );
}
